import { merge } from '@inpart-io/devtools';
import { type DataType } from '@inpart-io/devtools-iap';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { type DefaultCategory, type IPrivateLeadBoard, privateLeadBoardsManager } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getSearchModule } from '@/store/base/search/module';

import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';

const PRIVATE_LEAD_BOARD_MODULE = 'privateLeadBoard';

const state = { defaultBoards: new Map<DataType, Record<DefaultCategory, number>>() };

const searchModule = getSearchModule();
const dataObjectModule = getDataObjectsModule<IPrivateLeadBoard>(privateLeadBoardsManager, 5);

const privateLeadBoardModuleInstance = merge<unknown>(dataObjectModule, searchModule, { state, actions, getters, mutations });
store.registerModule(PRIVATE_LEAD_BOARD_MODULE, privateLeadBoardModuleInstance);

export { PRIVATE_LEAD_BOARD_MODULE };
